<template>
  <div class="service">
    <div class="bj-img">
      <div class="wrap">
        <div class="logo">
            <span>服务体系</span>
            <img src="@/assets/images/logo2.png">
            <p>云洋科技</p>
        </div>
        <div class="services">
          <div class="title">
              <h3>我们的服务覆盖</h3>
              <span>解决方案 <img src="@/assets/images/icon1.png"></span>
          </div>
          <div class="item-box">
            <div class="service-item" style="top: 40%; left: 11%;">
              <div class="service-circle bg1">
                <p>AI能力</p>
              </div>
            </div>
            <div class="service-item" style="top: 40%; right: 11%;">
              <div class="service-circle bg3">
                <p>云计算</p>
                  </div>
                </div>
            <div class="service-item" style="top: 10%; left: 26%;">
              <div class="service-circle bg2">
                <p>官网宣传</p>
              </div>
            </div>
            <div class="service-item" style="top: 10%; right: 26%;">
              <div class="service-circle bg4">
                <p>精准定位</p>
              </div>
            </div>
            <div class="service-item" style="left: 22%; top: 48%;">
              <div class="service-circle bg5">
                <p>教育培训</p>
              </div>
            </div>
            <div class="service-item" style="right: 22%; top: 48%;">
              <div class="service-circle bg6">
                <p>用户体验</p>
              </div>
            </div>
            <div class="service-item" style="left: 26%; bottom: 10%;">
              <div class="service-circle bg7">
                <p>数字化</p>
              </div>
            </div>
            <div class="service-item" style="right: 26%; bottom: 10%;">
              <div class="service-circle bg8">
                <p>企业赋能</p>
              </div>
            </div>
            <div class="service-item" style="top: 40%; left: 31%;">
              <div class="service-circle bg9">
                <p>电子商务</p>
              </div>
            </div>
            <div class="service-item" style="top: 40%; right: 32%;">
              <div class="service-circle bg10">
                <p>新零售</p>
              </div>
            </div>
            <div class="service-item" style="top: 72%; left: 36%;">
              <div class="service-circle bg11">
                <p>地产营销</p>
              </div>
            </div>
            <div class="service-item" style="top: 70%; right: 36%;">
              <div class="service-circle bg12">
                <p>本地生活</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style scoped>
  .service {
    width: 100%;
    overflow: hidden;
  }
  .bj-img{
    width: 100%;
    position: relative;
    height: 760px;
    background-image: url(../assets//images/service.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
  }
  .logo{
    width: 230px;
    height: 230px;
    position: absolute;
    display: flex;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    flex-direction: column;
    align-items: center;
    background: linear-gradient( 35deg, #f9f9f9 0%,#f9f9f9 40%,#dbdbdb 100%);
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0px 10px 25px rgba(73, 73, 73, 0.1), 0px 5px 15px rgba(73, 73, 73, 0.1); /* 添加阴影效果 */
    justify-content: space-around;
    padding: 20px;
    transition: transform 0.3s ease-in-out;
    z-index: 2;
  }
  .logo:hover {
    transform: scale(1.1);
  }
  .logo>img{
    width: 50%;
    display: block;
  }
  .logo span{
    font-size: 18px;
    color: #888888;
  }
  .logo p{
    font-size: 22px;
    color: #111111;
  }

  .services{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }
  .services .title{
    text-align: center;
    margin-top: 88px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }
  .services .title span{
    display: inline-flex;
    align-items: center;
    font-size: 18px;
    margin: auto;
  }
  .services .title span img {
    margin-left: 5px; 
    vertical-align: middle;
    width: 15px;
    height: 15px;
  }

.service-circle {
  cursor: pointer;
  width: 60px;
  height: 60px;
  background-color: #f0f0f0;
  border-radius: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  padding: 10px;
}

.service-item {
  position: absolute;
  text-align: center;
}

.service-item:hover .service-circle {
  transform: scale(1.1);
}
.service-circle p {
  font-size: 19px;
  font-weight: bold;
  color: #fff;
  line-height: 25px;
}
.bg1{
  background-color: #ce9e01;
}
.bg2{
  background-color: #ef8143;
}
.bg3{
  background-color: #ea737b;
}
.bg4{
  background-color: #195acf;
}
.bg5{
  background-color: #4679ea;
}
.bg6{
  background-color: #42a251;
}
.bg7{
  background-color: #e15227;
}
.bg8{
  background-color: #3a77f2;
}
.bg9{
  background-color: #332532;
  width: 100px;
  height: 100px;
}
.bg9 p{
  font-size: 32px;
  line-height: 38px;
}
.bg10{
  background-color: #fc4e2a;
  width: 100px;
  height: 100px;
}
.bg10 p{
  font-size: 32px;
  line-height: 38px;
}
.bg11{
  background-color: #cf3b38;
}
.bg12{
  background-color: #f0803f;
  width: 100px;
  height: 100px;
}
.bg12 p{
  font-size: 32px;
  line-height: 38px;
}
  </style>
  